import { render } from "./jqzysj.vue?vue&type=template&id=a1922eba&scoped=true&ts=true"
import script from "./jqzysj.vue?vue&type=script&lang=ts"
export * from "./jqzysj.vue?vue&type=script&lang=ts"

import "./jqzysj.vue?vue&type=style&index=0&id=a1922eba&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1922eba"]])

export default __exports__